import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiConfiguration } from '@klubovna/api-client';
import {
  userDocumentsControllerDeleteDocument,
  userDocumentsControllerGetDocuments,
  userDocumentsControllerUploadDocument,
} from '@klubovna/api-client';
import { UserDocument } from '@klubovna/api-client';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class UserDocumentsApiService {
  private http = inject(HttpClient);
  private apiConfig = inject(ApiConfiguration);

  getDocuments(userId: string): Observable<UserDocument[]> {
    return userDocumentsControllerGetDocuments(this.http, this.apiConfig.rootUrl, { userId })
      .pipe(map(response => response.body as UserDocument[]));
  }

  uploadDocument(userId: string, file: File): Observable<UserDocument> {
    return userDocumentsControllerUploadDocument(this.http, this.apiConfig.rootUrl, {
      userId,
      body: { file },
    }).pipe(map(response => response.body as UserDocument));
  }

  downloadDocument(userId: string, documentId: string): Observable<Blob> {
    const url = `${ this.apiConfig.rootUrl }/user-documents/${ userId }/${ documentId }/download`;
    return this.http.get(url, { responseType: 'blob' });
  }

  deleteDocument(userId: string, documentId: string): Observable<void> {
    return userDocumentsControllerDeleteDocument(this.http, this.apiConfig.rootUrl, {
      userId,
      documentId,
    }).pipe(map(() => undefined));
  }
}
